<template>
    <div class="base-form-div">
        <el-form size="mini" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="名称" prop="name">
                <el-input v-model="ruleForm.name" placeholder="请输入动作名称"></el-input>
            </el-form-item>
            <el-form-item label="模型" prop="data">
                <el-select v-model="ruleForm.data" placeholder="请选择模型">
                    <el-option v-for="item in typeOptions" :key="item.key" :label="item.label" :value="item.key">
                    </el-option>
                </el-select>
            </el-form-item>
            <!-- <el-form-item label="坐标" prop="coordinate">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 2 }" placeholder="单击绘制按钮后开始绘制,右键结束绘制"
                    v-model="ruleForm.coordinate"></el-input>
            </el-form-item> -->
            <div class="form-bottom">
                <el-button class="base-button" size="mini" type="primary" :disabled="drawDone"
                    @click="drawCoordinate">绘制</el-button>
                <el-button class="base-button" size="mini" type="primary" @click="submitForm('ruleForm')">创建</el-button>
                <!-- <el-button class="base-button" size="mini" @click="resetForm('ruleForm')">重置</el-button> -->
            </div>
        </el-form>
    </div>
</template>
<script>
import DrawHelper from "../lib/DrawPoint.js"
let DrawUti = undefined;
import * as Help from "./help"
let plotArr = [];
export default {
    props: ["subData"],
    data() {
        return {
            typeOptions: [
                {
                    key: NG_Server+"/gisData/glb/leida.glb",
                    label: '雷达'
                },
                {
                    key: NG_Server+"/gisData/glb/xiaofangyuan.glb",
                    label: '消防员'
                },
                // {
                //     key: NG_Server+"/gisData/glb/scene.gltf",
                //     label: 'test'
                // },
                {
                    key: NG_Server+"/gisData/glb/floor.gltf",
                    label: '建筑骨架'
                },
                {
                    key: NG_Server+"/gisData/glb/配电柜.gltf",
                    label: '配电柜'
                },
                {
                    key: NG_Server+"/gisData/glb/cs2.gltf",
                    label: '科技园区'
                },
                {
                    key: NG_Server+"/gisData/glb/car.gltf",
                    label: '小汽车'
                },
                {
                    key: NG_Server+"/gisData/glb/Noah博士_2.gltf",
                    label: 'Noah博士'
                },
                {
                    key: NG_Server+"/gisData/glb/weixin.gltf",
                    label: '卫星'
                },
                {
                    key: NG_Server+"/gisData/glb/xiaofangyuan-run.gltf",
                    label: '消防员'
                },
                {
                    key: NG_Server+"/gisData/glb/uav.gltf",
                    label: '无人机'
                },
                {
                    key: NG_Server+"/gisData/glb/blue.gltf",
                    label: '四面体'
                },
                {
                    key: NG_Server+"/gisData/glb/Human.glb",
                    label: '骨骼模型'
                },
                {
                    key: NG_Server+"/gisData/glb/Velociraptor.glb",
                    label: '恐龙'
                },
                {
                    key: NG_Server+"/gisData/glb/sjx.glb",
                    label: '四面体'
                },
                {
                    key: NG_Server+"/gisData/glb/和谐号.glb",
                    label: '和谐号'
                },
                {
                    key: NG_Server+"/gisData/glb/铲车.glb",
                    label: '铲车'
                },
                {
                    key: NG_Server+"/gisData/glb/叉车.glb",
                    label: '叉车'
                },
                {
                    key: NG_Server+"/gisData/glb/吊车.glb",
                    label: '吊车'
                },
                {
                    key: NG_Server+"/gisData/glb/Perseverance.glb",
                    label: '无人车'
                },
                {
                    key: NG_Server+"/gisData/glb/Ingenuity_v3.glb",
                    label: '无人机'
                },
                {
                    key: NG_Server+"/gisData/glb/arrow.glb",
                    label: '四棱锥'
                },
                {
                    key: NG_Server+"/gisData/glb/树.glb",
                    label: '树木'
                },
                {
                    key: NG_Server+"/gisData/glb/tree2.glb",
                    label: '树木2'
                },
                {
                    key: NG_Server+"/gisData/glb/test.glb",
                    label: '办公楼'
                },
                {
                    key: NG_Server+"/gisData/glb/yishuguan.glb",
                    label: '艺术馆'
                },
                {
                    key: NG_Server+"/gisData/glb/low-poly-ultimate-asset-pack.glb",
                    label: '展厅'
                },
                {
                    key: NG_Server+"/gisData/glb/huangguan.glb",
                    label: '皇冠'
                },
                {
                    key: NG_Server+"/gisData/glb/building.glb",
                    label: '建筑物'
                },
                {
                    key: NG_Server+"/gisData/glb/Hoveringdrone.glb",
                    label: '无人机'
                },
                {
                    key: NG_Server+"/gisData/glb/Ambulance.glb",
                    label: '医疗车'
                },
                {
                    key: NG_Server+"/gisData/glb/feiji.glb",
                    label: '飞机'
                },
                {
                    key: NG_Server+"/gisData/glb/XinHaoTa.glb",
                    label: '信号塔'
                },
                {
                    key: NG_Server+"/gisData/glb/qi_dian_chuan.glb",
                    label: '气垫船'
                },
                {
                    key: NG_Server+"/gisData/glb/HangKongMuJian.glb",
                    label: '航空母舰'
                },
                {
                    key: NG_Server+"/gisData/glb/renA.glb",
                    label: '人员A'
                },
                {
                    key: NG_Server+"/gisData/glb/renB.glb",
                    label: '人员B'
                },
                {
                    key: NG_Server+"/gisData/glb/dao_dan_ting.glb",
                    label: '船只'
                },
                {
                    key: NG_Server+"/gisData/glb/xiaofangcheA.gltf",
                    label: '救援车A'
                },
                {
                    key: NG_Server+"/gisData/glb/launchvehicle.glb",
                    label: '导弹'
                }
            ],
            ruleForm: {
                name: "",
                type: "pointModel",
                typeName: "模型标绘",
                delay: 1,
                data: NG_Server+"/gisData/glb/leida.glb",
                coordinate: "",
                params: {},
                view: {}
            },
            rules: {
                name: [
                    { required: true, message: "请选择围栏类型", trigger: "change" },
                ],
                data: [
                    { required: true, message: "请绘制围栏范围", trigger: "blur" }
                ],
                coordinate: [{ required: true, message: "请绘制围栏范围", trigger: "blur" }]
            },
            drawDone: false,
        };
    },
    methods: {
        submitForm(formName) {
            console.log(this.ruleForm);
            this.ruleForm.view = Help.getCameraView();
            this.$bus.$emit("addActionObj", JSON.parse(JSON.stringify(this.ruleForm)));
            this.resetForm("ruleForm");
            this.$parent.close();
        },
        resetForm(formName) {
            DrawUti && DrawUti.clear();
            this.$refs[formName].resetFields();
            this.drawDone = false;
            // for (let i = 0; i < plotArr.length; i++) {
            //     viewer.entities.remove(plotArr[i]);
            // }
        },
        getPlot(plot) {
            this.ruleForm.coordinate = plot.position.getValue();
            this.drawDone = true;

            var entity = Help.addGlb(this.ruleForm.data, plot.position.getValue());
            Help.addEntityArr(entity);
            this.$parent.reset();
        },
        
        drawCoordinate() {
            if (!DrawUti) {
                DrawUti = new DrawHelper({
                    canEdit: false,
                    callback: this.getPlot
                });
            }

            DrawUti.reset();
            DrawUti.start();
            this.$parent.min();
        }
    },
    created() {
    },
    mounted() { },
    beforeDestroy() {
        this.$refs['ruleForm'].resetFields();
        DrawUti && DrawUti.clear();
        DrawUti = undefined;
        for (let i = 0; i < plotArr.length; i++) {
            viewer.entities.remove(plotArr[i]);
        }
    }
};
</script>
<style>
.form-bottom {
    margin-bottom: 0 !important;
    text-align: center;
}

.el-input-number {
    width: 100%;
}
</style>